export enum FocusTarget {
  TAGLINE = 'tagline',
}
